export const AUTH_URL = Object.freeze({
  login: {
    name: 'auth.login',
    path: '/login',
  },
  recover: {
    name: 'auth.recover',
    path: '/recover',
  },
  register: {
    name: 'auth.register',
    path: '/register',
  },
});

export const AUTH_COOKIE_NAME = 'session_id';
